import * as React from 'react'
import type { LucideIcon } from 'lucide-react'

import { cn } from '@/lib/utils'

interface EmptyStateProps extends React.ComponentProps<'div'> {
  icon?: LucideIcon
  title: string
  description?: React.ReactNode
  action?: React.ReactNode
  /** Use `bordered` (default) for stand-alone cards, `bare` inside other surfaces. */
  variant?: 'bordered' | 'bare'
}

function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  variant = 'bordered',
  className,
  ...props
}: EmptyStateProps) {
  return (
    <div
      data-slot="empty-state"
      className={cn(
        'flex flex-col items-center gap-3 px-6 py-10 text-center',
        variant === 'bordered' &&
          'cockpit-panel rounded-lg border border-dashed',
        className,
      )}
      {...props}
    >
      {Icon ? (
        <div
          aria-hidden
          className="flex size-11 items-center justify-center rounded-full bg-primary-soft text-primary-soft-foreground"
        >
          <Icon className="size-5" />
        </div>
      ) : null}
      <div className="max-w-md space-y-1.5">
        <h3 className="text-sm font-semibold text-foreground">
          {title}
        </h3>
        {description ? (
          <p className="text-sm leading-relaxed text-muted-foreground">
            {description}
          </p>
        ) : null}
      </div>
      {action ? <div className="pt-1">{action}</div> : null}
    </div>
  )
}

export { EmptyState }
